import { render, staticRenderFns } from "./NameAndDescriptionSettings.vue?vue&type=template&id=11c988b3&scoped=true"
import script from "./NameAndDescriptionSettings.vue?vue&type=script&lang=ts"
export * from "./NameAndDescriptionSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c988b3",
  null
  
)

export default component.exports